var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderM',{class:{ show: _vm.HeaderMShow },attrs:{"isshow":_vm.HeaderMShow}}),_c('first-Component',{attrs:{"page":"index"},on:{"menushow":_vm.menushow}}),_c('div',{class:{ menushow: _vm.HeaderMShow },attrs:{"id":"page"}},[_c('div',{attrs:{"id":"scroller-wrapper","data-scrollbar":""}},[_c('home-Component')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }